import type { HTMLComponent } from "@commercekit/react";

const WvProductVariantsActionBar: HTMLComponent<{
  newItemName: string;
  newUomProperty: string;
  newUomQuantity: string | number;
  onAddToCart: (
    sku: string,
    uomProperty: string,
    uomQuantity: string | number
  ) => void;
  isLoading?: Boolean;
  isVariantLoading: Boolean;
  isInActive?: Boolean;
}> = ({
  newItemName,
  newUomProperty,
  onAddToCart,
  isLoading,
  isVariantLoading,
  newUomQuantity,
  isInActive,
}) => {
  return (
    <button
      type="button"
      disabled={isLoading || isInActive ? true : false}
      className="btn btn--primary btn--small"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onAddToCart(newItemName, newUomProperty, newUomQuantity);
      }}
    >
      {isVariantLoading && isLoading ? (
        <i className="zmdi-hc-spin" data-icon-after=""></i>
      ) : (
        <span className="mr-2" data-icon-after="">
          {" "}
          <svg width="25" height="21" xmlns="http://www.w3.org/2000/svg">
            <g fill="#FFF" fillRule="nonzero">
              <path d="M8.53 18.882a1.882 1.882 0 100 3.765 1.882 1.882 0 000-3.765zM21.706 18.882a1.882 1.882 0 100 3.765 1.882 1.882 0 000-3.765zM4.765.059c.45 0 .836.318.923.757l.004.02L8.378 16.06h14.27c.513 0 .93.411.94.922V17a.941.941 0 01-.922.941H7.588a.941.941 0 01-.923-.757l-.004-.02L3.975 1.94H1a.941.941 0 01-.941-.922V1C.059.486.47.069.98.059H4.765z"></path>
              <path d="M23.673 3.864c.636-.205 1.338.338 1.21 1.063l-.005.022-1.694 8.47a.941.941 0 01-.902.757H7.588a.941.941 0 01-.018-1.882h13.92l1.317-6.588H5.706a.941.941 0 01-.941-.923v-.018c0-.514.411-.931.922-.941h17.705c.09 0 .178.012.263.037l.014.004h.004z"></path>
            </g>
          </svg>
        </span>
      )}
    </button>
  );
};

export default WvProductVariantsActionBar;
